export default [
  {
    path: '/planos',
    name: 'app-admin-planos',
    component: () => import('@/views/apps/planos/list/ListPlanos.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Planos',
      action: 'read',
      resource: 'ADMIN_B2C',
      breadcrumb: [{ text: 'Planos', active: true }],
    },
  },
  {
    path: '/assinaturas',
    name: 'app-admin-assinaturas',
    component: () => import('@/views/apps/planos/assinaturas/ListAssinaturas.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Assinaturas',
      action: 'read',
      resource: 'ADMIN_B2C',
      breadcrumb: [
        { text: 'Planos', to: { name: 'app-admin-planos' }, active: false },
        { text: 'Assinaturas', active: true },
      ],
    },
  },
]
